import { i18n, _t } from "app/i18n/i18n";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { DesktopMenu } from "../DesktopMenu";
import { DesktopPreferencesDropdown } from "./DesktopPreferencesDropdown";
import { SearchButton } from "../parts/SearchButton";
import NewDesignButton from "lib/NewDesignButton/NewDesignButton";

// TODO try rendering the NavDropDowns from renderDesktop
export const DesktopHeader = () => {
  const menuItems = useSelector((state) => state.menu.items);
  const path = useSelector((state) => state.filter).path;
  const lang = i18n.getLanguage();
  const assetMenus = menuItems[lang].map((item) => item.menu).filter((i) => i);
  const [openMenu, setOpenMenu] = useState();
  const activeMenu = openMenu || findActiveMenu(assetMenus, path);
  const [timer, setTimer] = useState();
  const setMenu = (menu) => () => setOpenMenu(menu);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => clearTimeout(timer), []); // for clean up only

  return (
    <Navbar.Collapse id="basic-navbar-nav" className="d-none d-md-block w-100">
      <Nav className="w-100 align-items-center text-nowrap">
        {assetMenus.map((menu, key) => (
          <NavDropdown
            key={key}
            show={menu === openMenu}
            title={_t(menu)}
            active={menu === activeMenu}
            onMouseEnter={setMenu(menu)}
            onMouseLeave={setMenu(false)}
            onClick={setMenu(menu)}
            onBlur={() => setTimer(setTimeout(menu === openMenu ? setMenu(false) : null))} // allow children's onfocus events to bubble
            onFocus={() => clearTimeout(timer)}
          >
            <DesktopMenu path={menu} />
          </NavDropdown>
        ))}
        <NewDesignButton />
        <SearchButton right className="d-none d-md-block" />
        <DesktopPreferencesDropdown openMenu={openMenu} setOpenMenu={setOpenMenu} />
      </Nav>
    </Navbar.Collapse>
  );
};

// menu item is active (bold) if path.includes menu item
const findActiveMenu = (menus, path = "") =>
  menus.reduce((acc, menu) => {
    /**If more than one item exists like /ESG/Economis or /SP__Credits space/*/
    let backslash = menu.replace(/\//g, "__");
    const regex = new RegExp(`/${backslash}/`, "g");
    const isExist = path.match(regex);

    if (path.includes(acc) && !isExist) {
      return acc;
    }
    if (isExist && isExist.length > 0) {
      return backslash.replace(/__/g, "/");
    }
    const isSpace = new RegExp(`/${backslash}`, "g");
    const backslashWithSpace = path.match(isSpace);
    if (backslashWithSpace && backslashWithSpace.length > 0) {
      return backslash.replace(/__/g, "/");
    }
    /**end */

    return path.includes(menu) ? menu : acc;
  }, "Home");
